import ActiveSsoDialog from '../store/schema/interfaces/ActiveSsoDialog';
import extensibilityState from '../store/store';

export default function getSsoDialog(): ActiveSsoDialog {
    return extensibilityState.activeSsoDialog;
}
